import { LeadCount } from "../../types"
import {
  getMonth,
  groupByYearMonth,
  parseYearMonthKey,
  sortYearMonthKeys
} from "."

export interface MonthlyLeadCount {
  month: string
  year: string
  count: number
}

/**
 * Groups daily lead count data into monthly totals by year.
 */
export const groupLeadCountByMonth = (
  leadCounts: LeadCount[]
): MonthlyLeadCount[] => {
  const totals = groupByYearMonth(
    leadCounts,
    item => item.timestamp_tz_date,
    item => item.lead_count
  )

  const sortedKeys = sortYearMonthKeys(Object.keys(totals))

  return sortedKeys.map(key => {
    const { year, month } = parseYearMonthKey(key)
    return {
      month: getMonth(year, month),
      year: year.toString(),
      count: totals[key]
    }
  })
}
